import React, { useEffect, useState } from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { subscribeLoading } from '../api/client';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';
import { useT } from '../i18n/useT';

// Indicateur de chargement GLOBAL : visible dès qu'au moins une requête réseau
// (apiFetch ou fetchs des contexts) est en vol. Pastille flottante non bloquante
// en haut de l'écran — n'empêche pas l'interaction.
export default function GlobalLoadingIndicator() {
  const t = useT();
  const { isDarkTheme } = useTheme();
  const colors = getThemeColors(isDarkTheme);
  const [active, setActive] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeLoading(setActive), []);

  // Anti-scintillement (CCT-177) : n'afficher la pastille qu'après ~250 ms de chargement CONTINU
  // (les requêtes rapides ne font plus « flasher » le spinner) ; masquage immédiat dès la fin.
  useEffect(() => {
    if (!active) { setVisible(false); return; }
    const t = setTimeout(() => setVisible(true), 250);
    return () => clearTimeout(t);
  }, [active]);

  if (!visible) return null;

  return (
    <View pointerEvents="none" style={styles.wrap}>
      <View style={[styles.pill, { backgroundColor: colors.surface, borderColor: colors.border }]}>
        <ActivityIndicator size="small" color={colors.primary} style={{ marginRight: 8 }} />
        <Text style={[styles.pillText, { color: colors.textSecondary }]}>{t('common.syncing')}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: 12,
    left: 0,
    right: 0,
    alignItems: 'center',
    zIndex: 9999,
  },
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 36,
    paddingHorizontal: 14,
    borderRadius: 18,
    borderWidth: 1,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.18,
    shadowRadius: 6,
    elevation: 6,
  },
  pillText: { fontSize: 13, fontWeight: '500' },
});
